import { render, staticRenderFns } from "./PageMenu.vue?vue&type=template&id=cecb9484"
import script from "./PageMenu.vue?vue&type=script&lang=js"
export * from "./PageMenu.vue?vue&type=script&lang=js"
import style0 from "./PageMenu.vue?vue&type=style&index=0&id=cecb9484&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cecb9484')) {
      api.createRecord('cecb9484', component.options)
    } else {
      api.reload('cecb9484', component.options)
    }
    module.hot.accept("./PageMenu.vue?vue&type=template&id=cecb9484", function () {
      api.rerender('cecb9484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageMenu.vue"
export default component.exports